import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Acquisitions_Pendings_Products_Object} state
 *  @property {object} model
 *  @property {Acquisitions_Pendings_Products_Properties} model.properties
 *  @property {Acquisitions_Pendings_Products_Is} model.is
 *  @property {Acquisitions_Pendings_Products_Has} model.has
 */
export default class AcquisitionProductUpdateObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Acquisitions_Pendings_Products._name);
	}

	/**
	 * @param prevProps
	 * @param {Products_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Acquisitions_Pendings_Products_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.serial_number);
		}
	}

	//Note: Doesn't need a form() function. Only ever used in a modal
	render() {
		/** @type {Acquisitions_Pendings_Products_Properties} properties */
		let properties = this.model.properties;
		/** @type {Acquisitions_Pendings_Products_Object} object */
		let object = this.state;
		let {loading} = this.state;
		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-md"}>
							{/*#region ATF Required Information*/}
							<h4 className="section-title">ATF Required Information</h4>
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									property={properties.type}
									value={object.type}
									error={object.type_error}
									model={Types.Products_Types._name}
									id={'name'}
									nullable={false}
									limit={null}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									property={properties.manufacturer}
									value={object.manufacturer}
									error={object.manufacturer_error}
									object={object.manufacturers}
									nullable={true}
									default={{value: '', label: 'Other (Manual Entry)'}}
									defaultFirst={true}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Manufacturer (Manual Entry)"}
									value={object.manufacturer_other}
									error={object.manufacturer_other_error}
									property={properties.manufacturer_other}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Importer (If Imported)"}
									value={object.importer}
									error={object.importer_error}
									property={properties.importer}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Model"}
									value={object.model}
									error={object.model_error}
									property={properties.model}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									property={properties.caliber}
									value={object.caliber}
									error={object.caliber_error}
									object={object.calibers}
									nullable={true}
									default={{value: '', label: 'Other (Manual Entry)'}}
									defaultFirst={true}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Caliber (Manual Entry)"}
									value={object.caliber_other}
									error={object.caliber_other_error}
									property={properties.caliber_other}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={"row"}>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Barrel Length"}
											value={object.barrel_length}
											error={object.barrel_length_error}
											property={properties.barrel_length}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Overall Length"}
											value={object.overall_length}
											error={object.overall_length_error}
											property={properties.overall_length}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							{/*#endregion*/}
						</div>
						<div className={"col-md"}>
							<h4 className="section-title">ATF Regulated Item</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Serial Number"}
									value={object.serial_number}
									error={object.serial_number_error}
									property={properties.serial_number}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#region Product Details*/}
							<h4 className="section-title">Product Details</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"SKU"}
									value={object.sku}
									error={object.sku_error}
									property={properties.sku}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Product Description"}
									value={object.item_description}
									error={object.item_description_error}
									property={properties.item_description}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
								/>
							</div>
							{/*#endregion*/}
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
